import { LicenseType } from '@carsys/enums/license-type'
import { IDistributor } from '@cbgms/api/support'
import { IShopByCompany } from '@cbgms/api'
import HaynesProFields from './HaynesProFields'

interface IOptionalLicenseFieldsProps {
  distributor: IDistributor
  form: string
  shop?: IShopByCompany
  companyCountry: string
  companyUUID: string
}

const OptionalLicenseFields = ({ distributor, form, shop, companyCountry, companyUUID }: IOptionalLicenseFieldsProps) => {
  switch (distributor.LicenseType) {
    case LicenseType.HaynesPro:
      return <HaynesProFields form={form} distributor={distributor} shop={shop} companyCountry={companyCountry} companyUUID={companyUUID} />
    default:
      return null
  }
}

export default OptionalLicenseFields
